import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import VehicleMakeImage from 'app/vehicles/components/DashboardDetails/VehicleMakeImage.Mui'
import { useOnEnterHandler } from '@carsys/ui/src/helpers/keyboard/use-on-enter-handler'
import { IBrand } from './BrandCardList'

interface BrandCardProps {
  brand: IBrand
  focus?: boolean
  selectedKey?: string
  onBrandSelect: (key: string, value: any) => void
}

export function BrandCard({ brand, focus, selectedKey, onBrandSelect }: BrandCardProps) {
  useOnEnterHandler(focus, () => onBrandSelect(brand.name, brand))

  return (
    <Grid item lg={2} md={4} xs={6}>
      <Card
        variant='outlined'
        tabIndex={focus ? 0 : -1}
        onClick={() => onBrandSelect(brand.name, brand)}
        data-testid='select-card-item'
        raised={!!selectedKey && selectedKey === brand.key}
      >
        <CardActionArea className={focus ? 'Mui-focusVisible' : ''} data-testid='select-card-action'>
          <CardContent sx={{ p: 0.5 }} data-testid='brandselection-row'>
            <Stack direction='row' spacing={0.5} alignContent='center'>
              <Box alignSelf='center' display='flex'>
                <VehicleMakeImage manufacturer={brand.name} imageSize='normal' />
              </Box>
              <Typography
                sx={{ maxWidth: '10rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                variant='subtitle1'
                alignSelf='center'
                component='div'
                className='title'
              >
                {brand.name}
              </Typography>
            </Stack>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  )
}
